import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const List = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  gap: '8px',
});

export default function CustomPagination({
  totalPages,
  currentPage,
  handleChange,
}) {
  const { t } = useTranslation();

  const getPaginationItems = () => {
    const items = [];

    // First page
    if (currentPage > 2) {
      items.push({ type: 'page', page: 1 });
    }

    // Start ellipsis
    if (currentPage > 3) {
      items.push({ type: 'ellipsis' });
    }

    // Current page and its neighbors
    if (currentPage > 1) {
      items.push({ type: 'page', page: currentPage - 1 });
    }
    items.push({ type: 'page', page: currentPage, selected: true });
    if (currentPage < totalPages) {
      items.push({ type: 'page', page: currentPage + 1 });
    }

    // End ellipsis
    if (currentPage < totalPages - 2) {
      items.push({ type: 'ellipsis' });
    }

    // Last page
    if (currentPage < totalPages - 1) {
      items.push({ type: 'page', page: totalPages });
    }

    return items;
  };

  const items = getPaginationItems();

  return (
    <nav>
      <List className="table-pagination pagebtn-u">
        {/* Previous Button */}
        <li>
          <button
            type="button"
            onClick={() => handleChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="prev-button"
          >
            {t('common.previous')}
          </button>
        </li>

        {/* Pagination Items */}
        {items.map(({ type, page, selected }, index) => {
          if (type === 'ellipsis') {
            return <li key={index}>…</li>;
          }
          if (type === 'page') {
            return (
              <li key={index}>
                <button
                  type="button"
                  className={selected ? 'active' : ''}
                  onClick={() => handleChange(page)}
                >
                  {page}
                </button>
              </li>
            );
          }
          return null;
        })}

        {/* Next Button */}
        <li>
          <button
            type="button"
            onClick={() => handleChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="next-button"
          >
            {t('common.next')}
          </button>
        </li>
      </List>
    </nav>
  );
}
